import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";

const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  margin: "0px 100px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    margin: "0px 10px",
  },
}));
const OptionSelect = styled("option")(({ theme }) => ({
  color: "black",
  background: "white",
  display: "flex",
  whiteSpace: "pre",
  minHeight: "20px",
  textAlign: "center",
  fontSize: "18px",
}));
const CssNativeSelect = styled(NativeSelect)({
  "& .MuiNativeSelect-select": {
    textAlign: "center",
    paddingTop: "12px",
  },
});
const ContentDialog = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  padding: "15px",
}));
const BoxDialog = styled("div")(({ theme }) => ({
  display: "flex",
  m: "auto",
  position: "relative",
}));
const ButtonCancel = styled("button")(({ theme }) => ({
  backgroundColor: "#9F9F9F",
  margin: "15px",
  textAlign: "center",
  padding: "5px",
  paddingLeft: "18px",
  paddingRight: "18px",
  borderRadius: "18px",
  border: "0px",
  color: "white",
  "&:hover": {
    backgroundColor: "#D2D1D1",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
export {
  Root,
  OptionSelect,
  CssNativeSelect,
  ContentDialog,
  BoxDialog,
  ButtonCancel,
};
